import requestReducer from '../requestReducer';
import BouncedReceipt from '../../models/BouncedReceipt';
import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'


export interface BouncedReceiptDetailState extends PaginatedApiState {
  bouncedReceiptLines?: BouncedReceipt[]
}

const BouncedReceiptDetail = (state: BouncedReceiptDetailState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<BouncedReceiptDetailState>('BOUNCED_RECEIPT_DETAIL')(state, action)
  }
}

export default BouncedReceiptDetail